import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios";



export const loadExpenseReports = async () => {
  try {
    const response = await Axios.get('/expense-reports');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};



export const loadExpenseReport = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('/setups/expense-reports');
        const requestData = await response.data;
        return {...requestData, expenseReport: {}};
        
      default:
        const respnse = await Axios.get('/expense-reports/find/'+action);
        const responseData = await respnse.data;
        return responseData;
    }
  }catch (err) {
    throw err;
  }
}

const useExpenseReportAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('/expense-reports', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('expense', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('/expense-reports/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('expense', data.seo);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useExpenseReportAPI;


